import React, { createContext, useContext, useEffect, useState } from "react";

const STRINGS = {
  ru: {
    brand: "Realty",
    nav_rent: "Аренда",
    nav_sale: "Продажа",
    nav_daily: "Посуточно",
    nav_agents: "Риелторам",
    postAd: "Разместить объявление",
    hero_title: "Найдите дом мечты в России",
    hero_subtitle: "Тысячи проверенных объявлений об аренде и продаже недвижимости",
    tab_buy: "Купить",
    tab_rent: "Снять",
    tab_daily: "Посуточно",
    checkIn: "Заезд",
    checkOut: "Выезд",
    f_propertyType: "Тип недвижимости",
    deal_type: "Тип сделки",
    f_city: "Город",
    f_rooms: "Комнаты",
    f_price: "Цена, ₽",
    f_area: "Площадь, м²",
    priceFrom: "От",
    priceTo: "До",
    anyCity: "Любой город",
    anyType: "Любой тип",
    search: "Найти объявления",
    results_found: "Найдено",
    objects: "объектов",
    sort_label: "Сортировка",
    sort_gold: "Сначала Gold / Премиум",
    sort_price_asc: "Дешевле",
    sort_price_desc: "Дороже",
    sort_new: "Новые",
    reset: "Сбросить",
    filters: "Фильтры",
    apply: "Применить",
    empty_title: "Ничего не найдено",
    empty_sub: "Попробуйте изменить параметры поиска",
    priceOnRequest: "Цена по запросу",
    perMonth: "/мес",
    perDay: "/сутки",
    verified: "Проверено фото",
    gold: "Gold",
    view_on_cms: "Записаться на показ на Tagdada",
    open_new_tab: "Откроется на Tagdada в новой вкладке",
    back_to_results: "Назад к результатам",
    specs: "Характеристики",
    area: "Площадь",
    rooms: "Комнаты",
    floor: "Этаж",
    kitchen: "Кухня",
    builtYear: "Год постройки",
    bathrooms: "Санузлы",
    parking: "Парковка",
    yes: "Да",
    no: "Нет",
    studio: "Студия",
    description: "Описание",
    building: "О здании",
    contact: "Контакт",
    floorPlan: "Планировка",
    demoBanner: "Демо-данные: живой фид Tagdada временно недоступен, показаны примеры объявлений.",
    announcement: "Tagdada — самый быстрый и удобный способ найти недвижимость: реальная, полная и прозрачная информация об объектах.",
    loading: "Загрузка объявлений…",
    anyRooms: "Любое",
    ok: "OK",
    cat_location: "Локация",
    cat_rooms: "Комнаты",
    cat_surface: "Площадь",
    cat_price: "Цена",
    cat_other: "Ещё",
    cat_amenities: "Удобства",
    f_district: "Район",
    f_metro: "Метро",
    f_metro_distance: "До метро",
    f_bedrooms: "Спальни",
    f_wc_separate: "Раздельный санузел",
    f_bath_tub: "Ванна",
    s_total: "Общая, м²",
    s_kitchen: "Кухня, м²",
    s_living: "Гостиная, м²",
    p_no_commission: "Без комиссии",
    o_parking: "Есть парковка",
    o_underground_only: "Только подземный паркинг",
    o_furnished: "Мебель",
    o_pets: "Можно с животными",
    o_available_from: "Доступно с",
    o_built_year: "Год постройки",
    o_publication: "Публикация",
    o_cargo_lift: "Грузовой лифт",
    o_direct_owner: "Только собственники",
    o_kids_allowed: "Можно с детьми",
    pub_any: "Любая дата",
    pub_3d: "Менее 3 дней",
    pub_week: "Менее недели",
    pub_month: "В этом месяце",
    pub_older: "Старше месяца",
    onlyGold: "Только Gold",
    onlyVerified: "Проверенные фото",
    owner_toggle: "Собственник",
    sort_size: "По площади",
    sort_availability: "По доступности",
    book_viewing: "Записаться на показ",
    earliest_today: "Сегодня",
    earliest_tomorrow: "Завтра",
    earliest_aftertomorrow: "Послезавтра",
    earliest_prefix: "Ближайший показ",
    all_photos: "Все фото",
    terrace: "Терраса",
    furnished_yes: "С мебелью",
    furnished_no: "Без мебели",
    pets_yes: "Можно с питомцами",
    pets_no: "Без животных",
    parking_out: "Наземный",
    parking_under: "Подземный",
    m_unit: "м",
    any_short: "Любое",
    from_short: "от",
    to_short: "до",
    published: "Опубликовано",
    footer_rights: "Все объявления предоставлены платформой Tagdada",
    available_from: "Доступно с",
    promise: "Реальные фото. Запись на просмотр 24/7 без звонков.",
    view_map: "Карта",
    view_on_map: "На карте",
    view_list: "Список",
    in_this_area: "в этой области",
    clear_map_selection: "Показать все в области",
    location_unavailable: "Геолокация недоступна",
    location_unavailable_n: "без геолокации",
    collapse_map: "Свернуть карту",
    expand_map: "Развернуть карту",
  },
  en: {
    brand: "Realty",
    nav_rent: "Rent",
    nav_sale: "Sale",
    nav_daily: "Daily",
    nav_agents: "For agents",
    postAd: "Post a listing",
    hero_title: "Find your dream home in Russia",
    hero_subtitle: "Thousands of verified listings for rent and sale",
    tab_buy: "Buy",
    tab_rent: "Rent",
    tab_daily: "Daily",
    checkIn: "Check-in",
    checkOut: "Check-out",
    f_propertyType: "Property type",
    deal_type: "Deal type",
    f_city: "City",
    f_rooms: "Rooms",
    f_price: "Price, ₽",
    f_area: "Area, m²",
    priceFrom: "From",
    priceTo: "To",
    anyCity: "Any city",
    anyType: "Any type",
    search: "Find listings",
    results_found: "Found",
    objects: "listings",
    sort_label: "Sort",
    sort_gold: "Gold / Premium first",
    sort_price_asc: "Cheapest",
    sort_price_desc: "Most expensive",
    sort_new: "Newest",
    reset: "Reset",
    filters: "Filters",
    apply: "Apply",
    empty_title: "Nothing found",
    empty_sub: "Try adjusting your search filters",
    priceOnRequest: "Price on request",
    perMonth: "/mo",
    perDay: "/day",
    verified: "Verified photo",
    gold: "Gold",
    view_on_cms: "Book a viewing on Tagdada",
    open_new_tab: "Opens on Tagdada in a new tab",
    back_to_results: "Back to results",
    specs: "Specifications",
    area: "Area",
    rooms: "Rooms",
    floor: "Floor",
    kitchen: "Kitchen",
    builtYear: "Built year",
    bathrooms: "Bathrooms",
    parking: "Parking",
    yes: "Yes",
    no: "No",
    studio: "Studio",
    description: "Description",
    building: "About the building",
    contact: "Contact",
    floorPlan: "Floor plan",
    demoBanner: "Demo data: the live Tagdada feed is temporarily unavailable, showing sample listings.",
    announcement: "Tagdada is the best & fastest way to find a property: real, full & transparent property information.",
    loading: "Loading listings…",
    anyRooms: "Any",
    ok: "OK",
    cat_location: "Location",
    cat_rooms: "Rooms",
    cat_surface: "Surface",
    cat_price: "Price",
    cat_other: "More",
    cat_amenities: "Amenities",
    f_district: "District",
    f_metro: "Metro",
    f_metro_distance: "To metro",
    f_bedrooms: "Bedrooms",
    f_wc_separate: "Separate WC",
    f_bath_tub: "Bathtub",
    s_total: "Total, m²",
    s_kitchen: "Kitchen, m²",
    s_living: "Living, m²",
    p_no_commission: "No commission",
    o_parking: "Parking available",
    o_underground_only: "Underground parking only",
    o_furnished: "Furnished",
    o_pets: "Pets allowed",
    o_available_from: "Available from",
    o_built_year: "Built year",
    o_publication: "Publication",
    o_cargo_lift: "Cargo lift",
    o_direct_owner: "Direct owners only",
    o_kids_allowed: "Kids allowed",
    pub_any: "Any date",
    pub_3d: "Less than 3 days",
    pub_week: "Less than a week",
    pub_month: "This month",
    pub_older: "Older than a month",
    onlyGold: "Gold only",
    onlyVerified: "Verified pictures",
    owner_toggle: "Owner",
    sort_size: "By size",
    sort_availability: "By availability",
    book_viewing: "Book a viewing",
    earliest_today: "Today",
    earliest_tomorrow: "Tomorrow",
    earliest_aftertomorrow: "Day after tomorrow",
    earliest_prefix: "Next slot",
    all_photos: "All photos",
    terrace: "Terrace",
    furnished_yes: "Furnished",
    furnished_no: "Unfurnished",
    pets_yes: "Pets allowed",
    pets_no: "No pets",
    parking_out: "Outdoor",
    parking_under: "Underground",
    m_unit: "m",
    any_short: "Any",
    from_short: "from",
    to_short: "to",
    published: "Published",
    footer_rights: "All listings provided by the Tagdada platform",
    available_from: "Available from",
    promise: "Real photos. Book a viewing 24/7, no phone calls.",
    view_map: "Map",
    view_on_map: "View on map",
    view_list: "List",
    in_this_area: "in this area",
    clear_map_selection: "Show all in this area",
    location_unavailable: "Location not available",
    location_unavailable_n: "have no map location",
    collapse_map: "Collapse map",
    expand_map: "Expand map",
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("realty_lang") || "ru");
  useEffect(() => {
    localStorage.setItem("realty_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (key) => STRINGS[lang][key] ?? key;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
